import { FunctionComponent, useMemo } from "react";

import { Dropdown } from "@/components/Dropdown/Dropdown";

import { LANGUAGE_NAME_MAP } from "../../types";
import { LanguageFlag } from "../../LanguageFlag";

interface LanguagePickerProps {
	value: string;
	onChange: (code: string) => void;
	label?: string;
}

export const LanguagePicker: FunctionComponent<LanguagePickerProps> = ({
	value,
	onChange,
	label,
}) => {
	const options = useMemo(
		() =>
			Object.entries(LANGUAGE_NAME_MAP).map(([code, name]) => ({
				id: code,
				title: name,
				icon: <LanguageFlag className="w-4 h-auto" language={code} title={code.toUpperCase()} />,
			})),
		[]
	);

	const selectedItem = useMemo(() => options.find((o) => o.id === value), [options, value]);

	return (
		<Dropdown
			floating
			data={options}
			defaultValue={selectedItem}
			handleSelect={(item) => onChange(item.id as string)}
			label={label}
		/>
	);
};
